import { useEffect, useRef } from 'react';

export const SimpleDialog = ({
  title,
  subtitle,
  actionButtonText,
  actionButtonClick,
  showDialog,
  closeDialog,
}: {
  title: string;
  subtitle: string;
  actionButtonText: string;
  actionButtonClick: () => void;
  closeDialog: () => void;
  showDialog: boolean;
}) => {
  const modalRef = useRef<HTMLDialogElement | null>(null);

  useEffect(() => {
    if (showDialog) {
      modalRef.current?.showModal();
    } else {
      modalRef.current?.close();
    }
  }, [showDialog]);

  return (
    <dialog ref={modalRef} className="modal">
      <div className="modal-box bg-main">
        <button
          onClick={closeDialog}
          className="btn btn-circle btn-ghost btn-sm absolute right-2 top-2"
        >
          ✕
        </button>
        <h3 className="text-lg font-bold">{title}</h3>
        <div className="mt-4">{subtitle}</div>
        <div className="mt-8 flex justify-end">
          <button className="btn btn-primary" onClick={actionButtonClick}>
            {actionButtonText}
          </button>
        </div>
      </div>
    </dialog>
  );
};
